var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8586 16.2988H9.50419C8.15459 16.2988 7.02527 15.3372 6.76586 14.0625H0V20.2123C0 21.7542 1.25455 23.0076 2.79535 23.0076H19.5674C21.1082 23.0076 22.3628 21.7542 22.3628 20.2123V14.0625H15.5969C15.3375 15.3372 14.2082 16.2988 12.8586 16.2988Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5674 5.11709H15.654V3.43988C15.654 1.89797 14.3994 0.644531 12.8586 0.644531H9.50419C7.96339 0.644531 6.70884 1.89797 6.70884 3.43988V5.11709H2.79535C1.25455 5.11709 0 6.37052 0 7.91244V12.9441H6.76586C7.02527 11.6694 8.15459 10.7078 9.50419 10.7078H12.8586C14.2082 10.7078 15.3375 11.6694 15.5969 12.9441H22.3628V7.91244C22.3628 6.37052 21.1082 5.11709 19.5674 5.11709ZM14.5358 5.11709H7.82698V3.43988C7.82698 2.51518 8.57948 1.76267 9.50419 1.76267H12.8586C13.7833 1.76267 14.5358 2.51518 14.5358 3.43988V5.11709Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8578 15.1786C13.7825 15.1786 14.535 14.4261 14.535 13.5014C14.535 12.5767 13.7825 11.8242 12.8578 11.8242H9.50338C8.57868 11.8242 7.82617 12.5767 7.82617 13.5014C7.82617 14.4261 8.57868 15.1786 9.50338 15.1786H12.8578Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.02c271d816d3ef753c8b58d1170d84b1.svg";
export { ForwardRef as ReactComponent };